<ul class="navbar-nav me-auto">
    <li class="nav-item">
        <!-- <app-nav-search /> -->
        <b style="font-weight:300;color:white;">
            {{ menuRights?.name }}
        </b>
    </li>
</ul>
